/** `SearchCountWidgetContainer` is a `AltContainer` component for the search count widget that shows thte total number
 * of search results found by a /search call at any given point in time
 */
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';

import FileUploadCallCardStore from 'stores/files/FileUploadCallCardStore';
import SearchStore from 'stores/SearchStore';

import {getCallsSearchResultsCount} from '@store/calls';

import SearchCountWidget from './SearchCountWidget';

class SearchCountWidgetContainer extends React.Component {
  static getStores() {
    return [SearchStore, FileUploadCallCardStore];
  }

  static getPropsFromStores() {
    return {
      count: getCallsSearchResultsCount(),
    };
  }

  render() {
    return (
      <AltContainer>
        <SearchCountWidget {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(SearchCountWidgetContainer);
